import { render, staticRenderFns } from "./nopermissions.vue?vue&type=template&id=c1bd97f2&scoped=true&"
import script from "./nopermissions.vue?vue&type=script&lang=js&"
export * from "./nopermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bd97f2",
  null
  
)

export default component.exports